import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { AppService } from "src/app/app.service";
import { Global } from "src/global";
import { Router, ActivatedRoute } from "@angular/router";

@Injectable({
  providedIn: "root",
})
export class NotificationService {
  constructor(
    public globals: Global, 
    private appservice: AppService,
    private route: ActivatedRoute
   ) 
  {
    this.badgeState$.subscribe((state) => {
      this.showBadge = state;
    });
   }
  private badgeState = new BehaviorSubject<boolean>(false);
  badgeState$ = this.badgeState.asObservable();
  unreadCount: number;
  incomplete: any[] = [];
  showBadge: boolean = false;
  notifications: any[] = [];
  lessonCount: number = 0;
  incompleteCount: number = 0;
  firstTwoNotifications: any[] = [];
  firstTwoIncomplete: any[] = [];

  setBadgeState(state: boolean) {
    this.badgeState.next(state);
  }

  notificationList() {
    const formData: FormData = new FormData();
    formData.append("User_GUID", this.globals.XRSUser.GUID);
    formData.append("User_Token", this.globals.XRSUser.UserToken);
    const paramLessonGuid = this.route.snapshot.queryParamMap.get('lessonguid') ?? '';
    formData.append("paramLessonGuid", paramLessonGuid);
    
    this.appservice.GetNotificationList(formData).subscribe((res) => {
      
      try {
        this.notifications = JSON.parse(res);
        this.lessonCount = this.notifications.length;
        this.firstTwoNotifications = this.notifications.slice(0, 2);
        this.updateBadgeStatus();
      } catch (e) {
        console.error(e);
      }
    });
  }

  incompleteLessonList() {
    const formData: FormData = new FormData();
    formData.append("User_GUID", this.globals.XRSUser.GUID);
    formData.append("User_Token", this.globals.XRSUser.UserToken);

    this.appservice.GetIncompleteLessonList(formData).subscribe((res) => {
      
      try {
        this.incomplete = JSON.parse(res);
        this.incompleteCount = this.incomplete.length;
        this.firstTwoIncomplete = this.incomplete.slice(0, 2);
        this.updateBadgeStatus();
      } catch (e) {
        console.error(e);
      }
    });
  }

  updateBadgeStatus() {
    const showBadge =
      (this.notifications && this.notifications.length > 0) ||
      (this.incomplete && this.incomplete.length > 0) ||
      (this.notifications &&
        this.notifications.length > 0 &&
        this.incomplete &&
        this.incomplete.length > 0);
    this.setBadgeState(showBadge);
  }
}
